import { api } from './api';
import {
  ForumPost,
  ForumComentario,
  ForumLike,
  CreateForumPostData,
  UpdateForumPostData,
  CreateForumComentarioData,
  ForumPostFilters,
  ForumPostsResponse,
} from '../types/forum';

// Posts
export async function listForumPosts(filters?: ForumPostFilters): Promise<ForumPostsResponse> {
  const params = new URLSearchParams();
  if (filters?.categoria) params.append('categoria', filters.categoria);
  if (filters?.search) params.append('search', filters.search);
  if (filters?.orderBy) params.append('orderBy', filters.orderBy);
  if (filters?.page) params.append('page', String(filters.page));
  if (filters?.limit) params.append('limit', String(filters.limit));

  const response = await api.get(`/forum?${params.toString()}`);
  return response.data;
}

export async function getForumPost(id: string): Promise<ForumPost> {
  const response = await api.get(`/forum/${id}`);
  return response.data;
}

export async function getMyForumPosts(): Promise<ForumPost[]> {
  const response = await api.get('/forum/meus-posts');
  return response.data;
}

export async function createForumPost(data: CreateForumPostData): Promise<ForumPost> {
  const response = await api.post('/forum', data);
  return response.data;
}

export async function updateForumPost(id: string, data: UpdateForumPostData): Promise<ForumPost> {
  const response = await api.put(`/forum/${id}`, data);
  return response.data;
}

export async function moderateForumPost(id: string, ativo: boolean): Promise<ForumPost> {
  const response = await api.patch(`/forum/${id}/moderar`, { ativo });
  return response.data;
}

export async function deleteForumPost(id: string): Promise<void> {
  await api.delete(`/forum/${id}`);
}

// Comentários
export async function getForumComentarios(postId: string): Promise<ForumComentario[]> {
  const response = await api.get(`/forum/${postId}/comentarios`);
  return response.data;
}

export async function createForumComentario(postId: string, data: CreateForumComentarioData): Promise<ForumComentario> {
  const response = await api.post(`/forum/${postId}/comentarios`, data);
  return response.data;
}

export async function replyForumComentario(comentarioId: string, data: CreateForumComentarioData): Promise<ForumComentario> {
  const response = await api.post(`/forum/comentarios/${comentarioId}/responder`, data);
  return response.data;
}

export async function updateForumComentario(comentarioId: string, conteudo: string): Promise<ForumComentario> {
  const response = await api.put(`/forum/comentarios/${comentarioId}`, { conteudo });
  return response.data;
}

export async function moderateForumComentario(comentarioId: string, ativo: boolean): Promise<ForumComentario> {
  const response = await api.patch(`/forum/comentarios/${comentarioId}/moderar`, { ativo });
  return response.data;
}

export async function deleteForumComentario(comentarioId: string): Promise<void> {
  await api.delete(`/forum/comentarios/${comentarioId}`);
}

// Likes
export async function togglePostLike(postId: string): Promise<{ liked: boolean; likes_count: number }> {
  const response = await api.post(`/forum/${postId}/like`);
  return response.data;
}

export async function toggleComentarioLike(comentarioId: string): Promise<{ liked: boolean; likes_count: number }> {
  const response = await api.post(`/forum/comentarios/${comentarioId}/like`);
  return response.data;
}

export async function getPostLikes(postId: string): Promise<ForumLike[]> {
  const response = await api.get(`/forum/${postId}/likes`);
  return response.data;
}

export async function getComentarioLikes(comentarioId: string): Promise<ForumLike[]> {
  const response = await api.get(`/forum/comentarios/${comentarioId}/likes`);
  return response.data;
}
